import { initialChartsAndTables } from './chartAndTable';
import { initialSnapshots } from './snapshot';
import { userContactInfo } from './userContactInfo';
import { reportProperties } from './reportProperties';
import { iHeartChartsAndTablesConfig, initialChartSelector } from '../customCustomerConfig/iHeartChartAndTable';
import { comprehensiveChartsAndTablesConfig, comprehensiveChartSelector } from '../customCustomerConfig/comprehensiveChartAndTable';

export const CustomReportConfig = {
  userContactInfo: userContactInfo,
  reportProperties: reportProperties,
  chartsAndTables: initialChartsAndTables,
  snapshots: initialSnapshots
};

export const iHeartCustomReportConfig = {
  chartsAndTables: iHeartChartsAndTablesConfig,
  chartSelector: initialChartSelector
}; 

export const ComprehensiveReportConfig = {
  chartsAndTables: comprehensiveChartsAndTablesConfig,
  chartSelector: comprehensiveChartSelector
}; 